export const SOCIAL_LINKS = {
  soundcloud: "https://soundcloud.com/gazmatek",
  instagram: "https://www.instagram.com/gazmatek/",
  facebook: "https://www.facebook.com/GZK6tm/",
  youtube: "https://www.youtube.com/@gazmatekrecords",
  email: "gazmatek@gmail.com",
};
